/*
    Allow enchanced dialog accessibility (depends on a11y-dialog.js).
*/
export default function () {
    /* global A11yDialog */
    const dialog = document.querySelector("#resource_dialog");
    if (!dialog) return;
    new A11yDialog(dialog);
}
